import {Product, ProductRentalType, ProductTranslations} from '../common/types/product'
import {exhaustSwitchCaseWithFallback} from '../common/utils/exhaustSwitchCase'
import {GQL_ProductFragment, GQL_ProductRentalType} from '../generated/graphql'

export const transformProductRentalType = (rentalType: GQL_ProductRentalType): ProductRentalType => {
  switch (rentalType) {
    case GQL_ProductRentalType.Rent:
      return 'rent'
    case GQL_ProductRentalType.Buy:
      return 'buy'
    default:
      return exhaustSwitchCaseWithFallback(rentalType, 'rent')
  }
}
export const transformProductRentalTypeToGQL = (rentalType: ProductRentalType): GQL_ProductRentalType => {
  switch (rentalType) {
    case 'rent':
      return GQL_ProductRentalType.Rent
    case 'buy':
      return GQL_ProductRentalType.Buy
    default:
      return exhaustSwitchCaseWithFallback(rentalType, GQL_ProductRentalType.Rent)
  }
}

const transformProductTranslations = (input: GQL_ProductFragment['translations']): ProductTranslations | undefined => {
  if (!input) return undefined
  const result: ProductTranslations = {}
  for (const lang of ['en', 'sv', 'no', 'da'] as const) {
    const entry = input[lang]
    if (entry) {
      result[lang] = {
        name: entry.name ?? undefined,
        description: entry.description ?? undefined,
      }
    }
  }
  return result
}

export const transformProduct = (product: GQL_ProductFragment): Product => ({
  id: product.id,
  description: product.description ?? undefined,
  imageName: product.imageName ?? undefined,
  maxRentTimeInMinutes: product.maxRentTimeInMinutes,
  name: product.name,
  priceWeight: product.priceWeights,
  rentalType: transformProductRentalType(product.rentalType),
  showInApi: product.showInApi,
  translationKey: product.translationKey ?? undefined,
  translations: transformProductTranslations(product.translations),
})
